import { IntlShape } from "react-intl";
import messages from "./messages";
import { MergeAuditLog } from "./types";

const hasFieldChanges = (auditLog: MergeAuditLog): boolean =>
  !!auditLog.field_changes &&
  typeof auditLog.field_changes === "object" &&
  !Array.isArray(auditLog.field_changes) &&
  Object.keys(auditLog.field_changes).length > 0;

// Account Merge AC1/AC2 (customer) + Patient Audit AC1 (patient) — exact
// wording for the two audit-log roles, branching on merge_type since this
// summary renders inside both the Customer and Patient drawers' shared
// AuditLogList. When fields were changed on the selected record, the summary
// and the "Fields edited" list are one sentence ("...and changed the
// following fields:"), not two separate blocks like the regular audit log
// title + "Fields edited:".
const getMergeAuditLogSummary = (
  auditLog: MergeAuditLog,
  formatMessage: IntlShape["formatMessage"],
): string => {
  const isPatient = auditLog.merge_type === "patient";

  if (auditLog.role === "selected") {
    const withChanges = hasFieldChanges(auditLog);
    let message = messages.mergedIntoThisCustomer;
    if (isPatient) {
      message = withChanges
        ? messages.mergedIntoThisPatientWithChanges
        : messages.mergedIntoThisPatient;
    } else if (withChanges) {
      message = messages.mergedIntoThisCustomerWithChanges;
    }

    return formatMessage(message, { count: auditLog.merge_count ?? 0 });
  }

  const otherMessage = isPatient
    ? messages.mergedIntoOtherPatient
    : messages.mergedIntoOtherCustomer;
  return formatMessage(otherMessage, {
    id: auditLog.target_record_id ?? "",
  });
};

export default getMergeAuditLogSummary;
